<!--
 * @Author: chenyourong
 * @Date: 2025-05-08 18:06:50
 * @LastEditors: chenyourong
 * @LastEditTime: 2026-03-19 15:09:00
 * @Description: 
 * @FilePath: /vue-admin-template-master/src/views/businessManage/shopList/index.vue
-->
<template>
  <div class="shop-list">
    <Search v-bind="filterAttrs" v-on="filterEvent"></Search>
    <Table
      :list-query-params.sync="listQueryParams"
      v-bind="tableAttrs"
      v-on="tableEvent"
    />
    <el-dialog
      :title="title"
      v-if="dialogFormVisible"
      :visible.sync="dialogFormVisible"
      width="572px"
      top="3vh"
    >
      <Detail
        ref="getTable"
        :title="title"
        :styleType="styleType"
        :tableData="dialogForm"
        :tableFormAttrs="dialogFormAttrs"
        formLabelWidth="91px"
        @resetSecret="resetSecret"
        :isEdit="title === '编辑门店'"
        @handleAreaChange="handleAreaChange"
      >
      </Detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm()">{{
          sureButtonsName
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Table from "@/components/Table/index.vue";
import Detail from "@/components/Detail/index.vue";
import Search from "@/components/Search/index.vue";
import md5 from "js-md5";
import { regionData } from "element-china-area-data";
import { extractProvinceCityDistrict } from "@/utils/index.js";

import {
  createStores,
  merchantList,
  storesList,
  changeStores,
  deleteStores,
  resetStoresSecret,
} from "@/api/business";
import { PASSWORD_PLACEHOLDER } from "@/utils/validate";

const DefaultTableQuery = {
  pageNum: 1,
  pageSize: 10,
};

export default {
  name: "businessList",
  components: {
    Table,
    Detail,
    Search,
  },
  data() {
    return {
      title: "添加门店",
      sureButtonsName: "添加",
      styleType: "dialog",
      regionData,
      // 参数
      listQueryParams: { ...DefaultTableQuery },
      tableData: [],
      tableConfig: [
        {
          label: "门店名称",
          minWidth: "160",
          maxWidth: "520",
          autoWidth: true,
          format: "highlight",
          highlightKeyword: "",
          value: "storeName",
        },
        {
          label: "门店地址",
          minWidth: "120",
          maxWidth: "400",
          autoWidth: true,
          value: "trimStoreAddr",
        },
        {
          label: "门店ID",
          minWidth: "80",
          maxWidth: "160",
          autoWidth: true,
          value: "storeId",
        },
        {
          label: "App ID",
          minWidth: "90",
          maxWidth: "220",
          autoWidth: true,
          value: "AppId",
        },
        {
          label: "App Secret",
          minWidth: "110",
          maxWidth: "280",
          autoWidth: true,
          value: "AppSecret",
        },
        {
          label: "IP白名单",
          minWidth: "100",
          maxWidth: "280",
          autoWidth: true,
          value: "ipWhiteList",
        },
        {
          label: "所属商户",
          minWidth: "90",
          maxWidth: "240",
          autoWidth: true,
          value: "merchantName",
        },
        {
          label: "联系人",
          minWidth: "70",
          maxWidth: "140",
          autoWidth: true,
          value: "contact",
        },
        {
          label: "手机号",
          minWidth: "90",
          maxWidth: "140",
          autoWidth: true,
          value: "phone",
        },
        {
          label: "状态",
          minWidth: "70",
          maxWidth: "90",
          autoWidth: true,
          format: "status",
          value: "status",
        },
      ],
      dialogFormAttrs: [
        {
          title: "门店名称:",
          placeholder: "请输入门店名称",
          type: "input",
          value: "storeName",
          required: true,
        },
        {
          title: "省市区/县:",
          placeholder: "请选择省市区/县",
          type: "multipleSelect",
          value: "area",
          required: true,
          options: [],
        },
        {
          title: "详细地址:",
          placeholder: "请输入详细地址",
          type: "textarea",
          value: "storeAddr",
          required: true,
        },
        {
          title: "门店ID:",
          placeholder: "系统自动生成",
          type: "input",
          inputType: "number",
          value: "storeId",
          disabled: true,
        },
        {
          title: "App ID:",
          placeholder: "系统自动生成",
          type: "input",
          value: "AppId",
          disabled: true,
        },
        {
          title: "App Secret:",
          placeholder: "系统自动生成",
          type: "input",
          value: "AppSecret",
          icon: "el-icon-refresh-right",
          disabled: true,
        },
        {
          title: "IP白名单:",
          placeholder: "请输入IP白名单,多个ip用英文逗号分隔",
          type: "textarea",
          value: "ipWhiteList",
        },
        {
          title: "所属商户:",
          placeholder: "请输入所属商户",
          type: "select",
          value: "merchantId",
          required: true,
          options: [],
        },
        {
          title: "联系人:",
          placeholder: "请输入联系人",
          type: "input",
          value: "contact",
          required: true,
        },
        {
          title: "手机号:",
          placeholder: "请输入手机号或座机号",
          type: "input",
          value: "phone",
          required: true,
          skipPhoneFormat: true,
        },
        {
          title: "邮箱:",
          placeholder: "请输入邮箱",
          type: "input",
          value: "email",
          required: true,
        },
        {
          title: "状态:",
          placeholder: "请输入邮箱",
          type: "radio",
          value: "status",
        },
        {
          title: "初始密码:",
          placeholder: PASSWORD_PLACEHOLDER,
          type: "input",
          inputType: "text",
          value: "passwd",
          isClosePwd: true,
        },
      ],
      // 表格加载loading
      loadingStatus: false,
      buttonsName: [
        {
          label: "编辑",
        },
        {
          label: "删除",
        },
      ],
      optionWidth: 148,
      dialogFormVisible: false,
      dialogForm: {},
      // url参数
      params: {
        pageSize: 10,
        pageNum: 0,
        searchKey: "",
        searchVal: "",
      },
      filterButtonText: [
        {
          label: "添加门店",
          type: "primary",
        },
        {
          label: "删除门店",
          type: "info",
        },
      ],
      filterOptions: [
        {
          type: "multiSelect",
          placeholder: "所属商户",
          inputValue: "",
          isSearch: false,
          inputWidth: "136px",
          selectWidth: "106px",
          noShowInput: true,
          options: [],
        },
        {
          type: "multiSelect",
          placeholder: "请选择",
          selectValue: "storeName",
          inputValue: "",
          isSearch: false,
          inputWidth: "264px",
          selectWidth: "105px",
          options: [
            {
              label: "门店名称",
              width: "90",
              value: "storeName",
            },
            {
              label: "门店ID",
              width: "120",
              value: "storeId",
            },
            {
              label: "手机号",
              width: "120",
              value: "phone",
            },
          ],
        },
        {
          type: "button",
        },
      ],
      selectedAreaText: "",
      dialogStoreId: "",
      multipleSelection: [],
    };
  },
  computed: {
    // 表格属性
    tableAttrs() {
      const config = this.tableConfig.map((item) => {
        if (item.value !== "storeName") return item;
        return {
          ...item,
          highlightKeyword:
            this.params.searchKey === "storeName"
              ? (this.params.searchVal || "").trim()
              : "",
        };
      });
      return {
        // 表头配置
        config,
        // 表格数据
        tableData: this.tableData,
        // loading
        loadingStatus: this.loadingStatus,
        // 按钮名称
        buttonsName: this.buttonsName,
        // 操作栏宽度
        optionColumnWidth: this.optionWidth,
        // 是否需要选择
        isSelection: true,
        isShowNumber: true,
      };
    },
    // 表格事件
    tableEvent() {
      return {
        // 按钮操作
        subOpitonButton: this.handleTableOption,
        // 分页
        subClickPagination: this.handleRefreshList,
        // 表格数据选择
        subSelected: this.handleSelectionChange,
      };
    },
    filterAttrs() {
      return {
        // 按钮名称
        filterButtonText: this.filterButtonText,
        filterOptions: this.filterOptions,
      };
    },
    filterEvent() {
      return {
        // 选择数据回调
        handleFilter: this.handleFilter,
        handleFilterButton: this.handleFilterButton,
        clickSearch: this.clickSearch,
      };
    },
  },
  watch: {
    multipleSelection: {
      handler: function (val) {
        this.filterButtonText.forEach((item) => {
          if (item.label === "删除门店") {
            item.type = val.length ? "primary" : "info";
          }
        });
      },
      immediate: true,
    },
  },
  created() {
    const params = {
      ...this.params,
      pageSize: 1000,
      pageNum: 0,
    };
    merchantList(params).then((res) => {
      // this.merchantList = res.data.list;
      const data = res.data.list;
      this.filterOptions[0].options = data.map((val) => {
        return {
          value: val.merchantId,
          label: val.merchantName,
        };
      });
      this.filterOptions[0].options.unshift({
        value: "",
        label: "所有",
      });
      // console.log("🚀 ~ this.tableFormAttrs.forEach ~ this.tableFormAttrs:", this.tableFormAttrs)
      // this.tableFormAttrs.forEach((item) => {
      //   if (item.value === "merchantId") {
      //     item.options = this.merchantList.map((val) => {
      //       return {
      //         value: val.merchantId,
      //         label: val.merchantName,
      //       };
      //     });
      //   }
      // });

      this.dialogFormAttrs.forEach((item) => {
        if (item.type === "multipleSelect") {
          item.options = this.regionData;
        }
        if (item.value === "merchantId") {
          data.forEach((val) => {
            item.options.push({
              label: val.merchantName,
              value: val.merchantId,
            });
          });
        }
      });
    });

    this.getList();
  },
  methods: {
    // 获取列表
    async getList(storeId) {
      try {
        // 表格加载loading
        this.loadingStatus = true;
        // 分页数据作为参数给服务端
        this.params.pageSize = this.listQueryParams.pageSize;
        this.params.pageNum = this.listQueryParams.pageNum - 1;
        // 发送请求,请求到的数据格式见下文，
        const { data } = await storesList(this.params);
        if (data.list) {
          data.list.forEach((item) => {
            if (item.storeId === storeId) {
              this.dialogForm.AppSecret = item.AppSecret;
            }
            item.status = item.status.toString();
            item.trimStoreAddr = item.storeAddr.split(' ').join('');
          });
        }
        this.listQueryParams.total = data.total;
        // 数据给表格
        this.tableData = data.list || [];
        this.loadingStatus = false;
      } catch (error) {
        console.log(error);
      }
    },
    resetSecret() {
      this.$confirm("确认重置App Secret?", "", {
        type: "warning",
        confirmButtonText: "是",
        cancelButtonText: "否",
      })
        .then((res) => {
          resetStoresSecret({
            storeId: this.dialogForm.storeId,
          }).then((res) => {
            this.getList(this.dialogForm.storeId);
            this.$message.success("重置App Secret成功");
          });
        })
        .catch(() => {
          this.$message.info(`已取消重置App Secret`);
        });
    },
    // 点击添加按钮
    submitForm() {
      this.$refs.getTable.getTableRef().validate((valid) => {
        if (valid) {
          const params = {
            storeName: this.dialogForm.storeName,
            // storeAddr: this.dialogForm.storeAddr,
            merchantId: this.dialogForm.merchantId,
            contact: this.dialogForm.contact,
            phone: this.dialogForm.phone,
            email: this.dialogForm.email,
            ipWhiteList: this.dialogForm.ipWhiteList,
            // passwd: this.dialogForm.passwd
            //   ? md5(md5(this.dialogForm.passwd))
            //   : md5(md5("")),
            status: Number(this.dialogForm.status),
          };
          params.storeAddr = this.buildStoreAddr();
          if (this.title === "添加门店") {
            params.passwd = md5(md5(this.dialogForm.passwd));
            createStores(params).then((res) => {
              this.getList();
              this.$message({
                message: "添加成功",
                type: "success",
              });
            });
            this.dialogFormVisible = false;
          }
          if (this.title === "编辑门店") {
            if (this.dialogForm.passwd) {
              params.passwd = md5(md5(this.dialogForm.passwd));
            } else {
              delete params.passwd;
            }
            params.storeId = this.dialogStoreId;
            changeStores(params).then((res) => {
              this.getList();
              this.$message({
                message: "修改成功",
                type: "success",
              });
            });
            this.dialogFormVisible = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    buildStoreAddr() {
      const areaPart = (this.selectedAreaText || "").trim();
      const addrPart = (this.dialogForm.storeAddr || "").trim();
      return [areaPart, addrPart].filter(Boolean).join(" ");
    },
    parseStoreAddrForEdit(storeAddr) {
      const fullAddr = (storeAddr || "").trim();
      if (!fullAddr) {
        this.dialogForm.area = [];
        this.selectedAreaText = "";
        this.dialogForm.storeAddr = "";
        return;
      }
      const arr = [];
      let currentOptions = this.regionData;
      fullAddr.split(" ").forEach((code) => {
        const option = currentOptions.find((item) => item.label === code);
        if (option) {
          arr.push(option.value);
          currentOptions = option.children || [];
        }
      });
      this.dialogForm.area = arr;
      this.selectedAreaText = extractProvinceCityDistrict(fullAddr);
      this.dialogForm.storeAddr = fullAddr.split(" ").slice(-1)[0];
    },
    handleAreaChange(value) {
      let areaText = "";
      let currentOptions = this.regionData;
      value.forEach((code) => {
        const option = currentOptions.find((item) => item.value === code);
        if (option) {
          areaText += option.label + " ";
          currentOptions = option.children || [];
        }
      });
      this.selectedAreaText = areaText;
    },
    // 删除商户
    deleteShopDialog() {
      this.$confirm("确定删除吗?", "", {
        type: "warning",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async () => {
          this.$message.success(" 删除成功");
        })
        .catch(() => {
          this.$message.info(" 已取消删除");
        });
    },
    handleFilter(val) {
      if (val.placeholder === "所属商户") {
        this.params.merchantId = val.selectValue;
      }
      this.params.searchKey = val.selectValue;
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(
        "🚀 ~ handleSelectionChange ~ this.multipleSelection:",
        this.multipleSelection
      );
    },
    // 点击编辑
    handleTableOption(index, row, option) {
      this.operationalData = { ...row };
      if (option.label === "查看") {
        console.log(index, row, option);
      } else if (option.label === "编辑") {
        var row = JSON.parse(JSON.stringify(row));
        this.dialogFormVisible = true;
        this.title = "编辑门店";
        this.sureButtonsName = "确定";
        this.dialogForm = row;
        this.dialogForm.status = row.status.toString();
        this.parseStoreAddrForEdit(this.dialogForm.storeAddr);
        this.dialogStoreId = this.dialogForm.storeId;

        this.dialogFormAttrs.forEach((val) => {
          if (val.isClosePwd) {
            val.title = "重置密码:";
          }
          if (val.value === "AppSecret") {
            val.icon = "el-icon-refresh-right";
          }
        });
        console.log(index, row, option);
      } else if (option.label === "删除") {
        this.$confirm("确定删除门店吗?", "", {
          type: "warning",
          confirmButtonText: "是",
          cancelButtonText: "否",
        })
          .then(async () => {
            deleteStores({
              storeIds: [row.storeId],
            }).then((res) => {
              this.getList();
              this.$message.success(" 删除成功");
            });
          })
          .catch(() => {
            this.$message.info(" 已取消删除");
          });

        console.log(index, row, option);
      }
    },
    // 分页操作
    handleRefreshList() {
      this.getList();
    },
    clickSearch(val) {
      this.params.searchKey = val.selectValue;
      this.params.searchVal = (val.inputValue || "").trim();
      this.listQueryParams.pageNum = 1; // 重置页码
      this.getList();
    },
    // 点击右上角添加门店或者删除门店按钮
    async handleFilterButton(val) {
      if (val === "添加门店") {
        this.dialogFormVisible = true;
        this.title = "添加门店";
        this.sureButtonsName = "添加";
        this.dialogForm = {};
        this.dialogFormAttrs.forEach((val) => {
          if (val.isClosePwd) {
            val.title = "初始密码:";
          }
          if (val.value === "AppSecret") {
            val.icon = "";
          }
        });
      }
      if (val === "删除门店") {
        if (!this.multipleSelection.length) return false;
        this.$confirm("确定删除吗?", "", {
          type: "warning",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(async () => {
            const storeIds = this.multipleSelection.map((val) => val.storeId);
            await deleteStores({
              storeIds,
            });
            this.getList();
            this.$message.success(" 删除成功");
          })
          .catch(() => {
            this.$message.info(" 已取消删除");
          });
      }
    },
  },
};
</script>
<style lang="scss">
.shop-list {
  .el-dialog__wrapper {
    display: inherit;
  }
  .filter-container {
    .el-input {
      width: 265px;
      input {
        height: 32px;
      }
      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
    .el-select {
      margin-right: 4px;
      .el-input {
        width: 106px;
      }
    }
    .el-input-group__append {
      background: #fff;
    }
    .el-button {
      padding: 12px;
    }
    .filter-container__left {
      .select-item:nth-child(1) {
        .el-select {
          margin-right: 0;
        }
      }
    }
    .filter-container__right {
      .el-button {
        width: 88px;
        height: 32px;
        line-height: 32px;
        padding: 0;
        font-size: 14px;
      }
      .el-button--primary {
        background: #1890ff;
      }
      .el-button--info {
        background: #f5f5f5;
        color: rgba(0, 0, 0, 0.25);
      }
    }
  }
  .deleteShopDialog {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      display: flex;
      align-items: center;
      border: none;
    }
    .el-icon-warning-outline {
      font-size: 22px;
      color: #faad14;
      margin-right: 16px;
    }
    .el-dialog__footer {
      padding: 0px 20px 20px;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
.shop-list {
  .filter-container {
    @include flex;
    justify-content: space-between;
    width: 100%;
    background: #fff;
  }
  .show-pwd {
    position: absolute;
    right: 60px;
    top: 0;
    font-size: 16px;
    color: #000;
    cursor: pointer;
    user-select: none;
  }
  .char-count {
    text-align: right;
    color: #666;
    font-size: 12px;
    margin-top: 4px;
  }

  .limit-reached {
    color: #f56c6c;
    font-weight: bold;
  }
}
</style>
